import { Component, ChangeDetectionStrategy, Input, OnChanges, Output, EventEmitter } from '@angular/core';
import { ContentMetaDataItemViewModel, ContentMetaDataListViewModel } from './content-meta-data.view-model';

@Component({
  selector: 'osn-shared-content-meta-data-list',
  templateUrl: './content-meta-data-list.component.html',
  styleUrls: ['./content-meta-data-list.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ContentMetaDataListComponent implements OnChanges {
  @Input() private readonly metaData: ContentMetaDataListViewModel;
  @Output() public contentClick = new EventEmitter<string>();
  public metaDataList: [string, ContentMetaDataItemViewModel[]][];

  public ngOnChanges(): void {
    this.setMetaDataGroups();
  }

  public onContentClick(contentName: string): void {
    this.contentClick.emit(contentName);
  }

  private setMetaDataGroups(): void {
    if (!this.metaData) {
      return;
    }
    this.metaDataList = Object.entries(this.metaData).filter((entry) => entry[1].length > 0);
  }
}
